import { NavLink } from "react-router-dom";
import { adminNavSections } from "@/mocks/admin/nav";

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function AdminSidebar({ open, onClose }: Props) {
  return (
    <>
      {/* Mobile overlay */}
      <div
        className={`fixed inset-0 z-30 bg-ink-900/40 backdrop-blur-sm lg:hidden transition-opacity ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={onClose}
      />

      <aside
        className={`fixed lg:static z-40 top-0 left-0 h-full w-72 bg-white border-r border-ink-100 flex flex-col transition-transform duration-300 ${
          open ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0`}
      >
        {/* Brand */}
        <div className="h-16 flex items-center gap-3 px-6 border-b border-ink-100">
          <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-ink-900 text-white">
            <i className="ri-truck-fill text-xl"></i>
          </div>
          <div>
            <div className="font-display text-lg font-bold leading-none">Haulmark</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-ink-400 mt-1">Movers HQ</div>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 overflow-y-auto scrollbar-thin py-5 px-3">
          {adminNavSections.map((section) => (
            <div key={section.title} className="mb-5">
              <div className="px-3 mb-2 text-[10px] uppercase tracking-[0.18em] text-ink-400 font-semibold">
                {section.title}
              </div>
              <ul className="space-y-1">
                {section.items.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      end={item.to === "/dashboard"}
                      onClick={onClose}
                      className={({ isActive }) =>
                        `group flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium cursor-pointer transition-colors whitespace-nowrap ${
                          isActive
                            ? "bg-ink-900 text-white"
                            : "text-ink-600 hover:bg-cream-100 hover:text-ink-900"
                        }`
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <span className="w-5 h-5 flex items-center justify-center">
                            <i className={`${item.icon} text-base`}></i>
                          </span>
                          <span className="flex-1">{item.label}</span>
                          {item.badge && (
                            <span
                              className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${
                                isActive
                                  ? "bg-white/15 text-white"
                                  : "bg-brand-100 text-brand-700"
                              }`}
                            >
                              {item.badge}
                            </span>
                          )}
                        </>
                      )}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>

      </aside>
    </>
  );
}